import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExerciseLogger = ({
  exercise,
  exerciseNumber,
  totalExercises,
  completedSets,
  onSkip
}) => {
  const progress = exercise?.target_sets > 0 
    ? (completedSets / exercise?.target_sets) * 100 
    : 0;

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="Dumbbell" size={24} className="text-primary" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
              {exercise?.exercise_name}
            </h2>
            <p className="text-sm text-muted-foreground">
              Exercise {exerciseNumber} of {totalExercises}
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onSkip}
          iconName="SkipForward"
        >
          Skip
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <div className="p-3 bg-muted rounded-lg">
          <p className="text-xs caption text-muted-foreground mb-1">Target Sets</p>
          <p className="text-lg font-bold data-text text-foreground">
            {exercise?.target_sets}
          </p>
        </div>
        <div className="p-3 bg-muted rounded-lg">
          <p className="text-xs caption text-muted-foreground mb-1">Target Reps</p>
          <p className="text-lg font-bold data-text text-foreground">
            {exercise?.target_reps || '-'}
          </p>
        </div>
        <div className="p-3 bg-muted rounded-lg">
          <p className="text-xs caption text-muted-foreground mb-1">Target Weight</p>
          <p className="text-lg font-bold data-text text-foreground">
            {exercise?.target_weight ? `${exercise?.target_weight} lbs` : '-'}
          </p>
        </div>
        <div className="p-3 bg-muted rounded-lg">
          <p className="text-xs caption text-muted-foreground mb-1">Muscle</p>
          <p className="text-lg font-bold data-text text-foreground">
            {exercise?.target_muscle || '-'}
          </p>
        </div>
      </div>

      <div className="mb-2">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm text-muted-foreground">
            Set Progress: {completedSets}/{exercise?.target_sets}
          </p>
          <p className="text-sm font-medium text-primary">
            {Math.round(progress)}%
          </p>
        </div>
        <div className="relative h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-primary rounded-full transition-smooth"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {exercise?.difficulty && (
        <div className="mt-3 p-3 bg-accent/10 border border-accent/20 rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="Info" size={16} className="text-accent" />
            <p className="text-xs text-muted-foreground">
              Difficulty: <span className="font-medium text-foreground">{exercise?.difficulty}</span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExerciseLogger;